import { Checkbox } from "components/Atoms/inputs/Checkbox";
import { Loading } from "components/panels";
import { VerticalKeyboardNavigationGroup } from "keyboardNavigation/KeyboardNavigationPresets";
import React from "react";
import { useTags } from "./hooks";

interface Props {
  mainArea: server.dto.MainAreas
  value: server.dto.TagSmall[]
  onChange: (tags: server.dto.TagSmall[]) => void
}

const TagsSelect = (props: Props) => {
  const tagsQuery = useTags(props.mainArea);

  const selected = new Set(props.value.map(v => v.tagId));

  const onChange = (tag: server.dto.TagSmall, checked: boolean) => {
    const newTags = checked
      ? [...props.value, tag]
      : props.value.filter(t => t.tagId !== tag.tagId);
    props.onChange(newTags);
  }

  if (tagsQuery.isLoading) {
    return <Loading />
  }

  const data = tagsQuery.data || [];

  return <div className="multiple-columns">
    {data.map(opt => (
      <div className="margin-bottom-mini" key={opt.tagId}>
        <Checkbox
          keyboardNavigationOptions={VerticalKeyboardNavigationGroup("tagSelect")}
          checked={selected.has(opt.tagId)}
          label={opt.title}
          onChange={(_, checked) => { onChange(opt, checked); }}
        />
      </div>
    ))}
  </div>;
};

export default TagsSelect;